function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: l , size: a = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = s(), c = l !== null && l !== void 0 ? l : e ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ r("path", {
            fill: c,
            d: "M20.446 2.155H12.86a1.401 1.401 0 00-.991 2.392l.697.698-6.221 6.22a1.402 1.402 0 000 1.981l4.196 4.2a1.402 1.402 0 001.98 0l6.222-6.225.708.712c.26.263.616.411.99.411.772 0 1.4-.627 1.402-1.4V3.556c0-.774-.624-1.401-1.397-1.401zm0 1.12c.154 0 .28.127.28.28v7.586a.28.28 0 01-.28.28h-.003a.274.274 0 01-.196-.084L18.75 9.841c-.07.062-.14.124-.204.194l-6.816 6.817a.279.279 0 01-.395 0l-4.198-4.198a.279.279 0 010-.395l6.815-6.815a.279.279 0 000-.395L12.66 3.757a.279.279 0 01.2-.476h7.585v-.006zm-18.3 18.009a.56.56 0 00.955.395l4.65-4.647a.561.561 0 00-.807-.779l-4.633 4.633a.562.562 0 00-.165.398zm5.597.563a.562.562 0 01-.56-.56.55.55 0 01.165-.395c.933-.934 2.018-2.063 2.243-2.298l.042-.044a.562.562 0 11.813.776c-.011.014-1.252 1.308-2.303 2.358a.583.583 0 01-.4.163zM2.196 16.3a.562.562 0 00.958.397 163.972 163.972 0 002.311-2.37.562.562 0 00-.82-.764l-.043.044c-.225.234-1.31 1.364-2.243 2.298a.56.56 0 00-.163.395z"
        })
    }));
}, v = i;
export { v as default };
